/** The example catalog shown in the picker (docs/examples.md). */
import { analyticsSniffing } from "./analytics-sniffing";
import { base64Eval } from "./base64-eval";
import { benignWidget } from "./benign-widget";
import { cookieBeacon } from "./cookie-beacon";
import { domInjector } from "./dom-injector";
import { fingerprinter } from "./fingerprinter";
import { functionChain } from "./function-chain";
import { globalHijack } from "./global-hijack";
import { magecartSkimmer } from "./magecart-skimmer";
import { npmBeacon } from "./npm-beacon";
import { remoteLoader } from "./remote-loader";
import { sandboxDetector } from "./sandbox-detector";
import { storageHoarder } from "./storage-hoarder";
import { stringBuiltFetch } from "./string-built-fetch";
import { timeBomb } from "./time-bomb";
import type { Example } from "./types";
import { walletDrainerProbe } from "./wallet-drainer-probe";

export type { Example } from "./types";

export const EXAMPLES: readonly Example[] = [
  stringBuiltFetch,
  analyticsSniffing,
  cookieBeacon,
  magecartSkimmer,
  storageHoarder,
  timeBomb,
  domInjector,
  fingerprinter,
  sandboxDetector,
  globalHijack,
  benignWidget,
  npmBeacon,
  base64Eval,
  functionChain,
  remoteLoader,
  walletDrainerProbe,
];

/**
 * Examples the web app can't run yet, kept in EXAMPLES so their golden tests
 * still run headlessly: npm-beacon needs ES module support in the web app.
 */
const HIDDEN: ReadonlySet<Example> = new Set([npmBeacon]);

/** The examples offered in the picker. */
export const PICKER_EXAMPLES: readonly Example[] = EXAMPLES.filter((e) => !HIDDEN.has(e));

/** What the app opens on (docs/examples.md, "Default selection"). */
export const DEFAULT_EXAMPLE: Example = base64Eval;
